import styled from 'styled-components';
import { Layout } from 'antd';

export const Header = styled(Layout.Header)`
  && {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    height: 160px;
    background: url(${({ src }) => `'${src}'`}) no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    background-color: #fff;
    padding: 0 2rem !important;
  }

  h1 {
    margin-left: 1rem;
  }

  @media (max-width: 480px) {
    justify-content: center !important;
    height: auto;

    h1 {
      display: block !important;
      width: 100%;
      font-size: 1.2rem !important;
      margin: 0;
    }
  }
`;
